import "./ChatNotificationBlock.css";
import { Button } from "@ui/Button.jsx";
import { createSignal } from "solid-js";
import type { NotificationState } from "../chatPanelState.ts";

type Props = {
	notification: NotificationState;
	onRefresh: () => void;
};

export const ChatNotificationBlock = (props: Props) => {
	const [refreshing, setRefreshing] = createSignal(false);

	return (
		<div class="notification">
			<div class="notification-panel">
				<h3>{props.notification.title ?? "Notification"}</h3>
				<p>{props.notification.message}</p>
				<div class="toolbar">
					<div class="right">
						<Button
							variant="text"
							class="secondary monochrome"
							symbol="refresh"
							disabled={refreshing()}
							onClick={() => {
								setRefreshing(true);
								props.onRefresh();
							}}
						>
							<span class="label">Refresh</span>
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};
